export default __webpack_public_path__ + "static/media/151w.22a57ee7.svg";